import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    IPackage,
    ModalResultType,
    NugetType,
} from '@models';
import { NugetServiceFactory } from '@pages/packages/shared/nuget.util';
import {
    CommonNugetService,
    LibraryService,
    PackageService,
} from '@services';

enum PackageVersionViewMode {
    Arguments,
    ReleaseNotes,
}

@Component({
    templateUrl: './nuget-versions.modal.html',
    styleUrls: [
        './nuget-versions.modal.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    providers: [
        CommonNugetService,
        LibraryService,
        PackageService,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NugetVersionsModalComponent
    extends UiModalComponent<IPackage> {

    public PackageVersionViewMode = PackageVersionViewMode;
    public currentPackageVersionViewMode?: PackageVersionViewMode;

    public nugetService = this._injector.get(NugetServiceFactory(this.context.additionalData.type));
    public selectedPackageVersion?: IPackage | null;
    public latestVersions?: IPackage[];

    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);
    private _commonNugetService = this._injector.get<CommonNugetService>(CommonNugetService);
    private _isHost = this._appState.user.loggedInAsHost;

    public get deletePermission() {
        if (this._isHost) { return ''; }

        return this.context.additionalData.type === NugetType.Libraries ?
            'Libraries.Delete' :
            'Packages.Delete';
    }

    public onClose(result: boolean) {
        if (result) {
            this._dialogRef.close({
                type: ModalResultType.Remove,
            });
        } else {
            this._dialogRef.close();
        }
    }

    public showVersions() {
        this.selectedPackageVersion = null;
    }

    public showInformation(packageVersion: IPackage, mode: PackageVersionViewMode) {
        this.currentPackageVersionViewMode = mode;
        this.selectedPackageVersion = packageVersion;
    }

    public get isDownloadEnabled(): boolean {
        return this._commonNugetService.isNugetDownloadEnabled(this.context.additionalData.type);
    }

    public downloadLink(entry: IPackage) {
        return this.nugetService.downloadLink(entry);
    }
}
